<script setup lang="ts">
import { useLoadingOverlay } from "@/store/overlays/loading-overlay.ts";
const loading_overlay = useLoadingOverlay();
</script>

<template>
  <v-overlay
    v-model="loading_overlay.is_visible"
    no-click-animation
    persistent
    z-index="900"
    class="align-center justify-center"
    style="background-color: rgb(255, 255, 255, 0.5)"
  >
    <v-progress-circular size="74" width="11" indeterminate />
  </v-overlay>
</template>

<style scoped lang="scss">
</style>

<!-- vim: softtabstop=2:shiftwidth=2
-->
